// Copyright © Veeam Software Group GmbH

import type { RouterConfig } from '@veeam/core';

import { Routes } from './Routes';
import { StubPaths } from './stub-paths';

export const routerConfig: RouterConfig<{}> = {
    noMatchName: StubPaths.NoMatch,
    noMatchRedirect: { name: Routes.Index },
    route: [
        {
            name: Routes.Index,
            path: '/',
            redirect: { name: Routes.Explore },
            child: [
                {
                    name: Routes.Explore,
                    path: `/${Routes.Explore}`,
                },
                {
                    name: Routes.RestoreSessions,
                    path: `/${Routes.RestoreSessions}`,
                },
                {
                    name: Routes.RecoveryList,
                    path: `/${Routes.RecoveryList}`,
                },
            ],
        },
    ],
};
